// extracted by mini-css-extract-plugin
export default {"join":"Footer_join__9O1uD","footer-list":"Footer_footer-list__LYJ7r","social":"Footer_social__oLTce","social-container":"Footer_social-container__MESRf"};